import { Component, OnDestroy } from '@angular/core';
import { HttpStatusEnum } from '@core/api';
import { TranslateModule } from '@ngx-translate/core';
import { SharedOrderApi } from '@shared/apis/shared-order.api';
import { AutoFocusModule } from 'primeng/autofocus';
import { ButtonModule } from 'primeng/button';
import { DialogModule } from 'primeng/dialog';
import { DividerModule } from 'primeng/divider';
import { Subscription } from 'rxjs';
import { DeleteDraftModalService } from './delete-draft-modal.service';

@Component({
    selector: 'app-delete-draft-modal',
    standalone: true,
    imports: [TranslateModule, ButtonModule, DividerModule, DialogModule, AutoFocusModule],
    templateUrl: './delete-draft-modal.component.html',
    styleUrls: ['./delete-draft-modal.component.scss'],
})
export class DeleteDraftModalComponent implements OnDestroy {
    deletionInProgress = false;
    selectedOrderId: number | null = null;

    private readonly subscriptions = new Subscription();

    constructor(
        private deleteDraftModalService: DeleteDraftModalService,
        private sharedOrderApi: SharedOrderApi
    ) {
        this.subscriptions.add(
            this.deleteDraftModalService.selectedOrderId$.subscribe(selectedOrderId => {
                this.selectedOrderId = selectedOrderId;
            })
        );
    }

    ngOnDestroy(): void {
        this.subscriptions.unsubscribe();
    }

    closeModal() {
        this.deleteDraftModalService.selectedOrderId$.next(null);
    }

    async confirmDeletion() {
        if (this.selectedOrderId === null) return;

        this.deletionInProgress = true;
        const response = await this.sharedOrderApi.deleteDraft(this.selectedOrderId);
        this.deletionInProgress = false;
        if (response.status === HttpStatusEnum.SUCCESS) {
            this.deleteDraftModalService.deletedSuccessfully(this.selectedOrderId);
            this.closeModal();
        }
    }
}
